import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getCurrentDate } from '../../../helpers/Common';
import { REDUCER_NAME, downloadPriceData } from '../reducer';
import ExportBlob from '../../../common/export-blob';

class ExportCommon extends React.Component {
  handleExport = () => {
    const {
      code,
      timeRangeFilter,
      dateRangeOption,
      downloadPriceData,
      currentTab,
      displayCode,
    } = this.props;
    const mapScreen = {
      1: 'Overview',
      2: 'OrderStatistic',
      3: 'Foreign',
      4: 'Proprietary',
    };

    const apiParams = {
      Code: code,
      Frequently: timeRangeFilter,
      From: dateRangeOption.FromDate,
      To: dateRangeOption.ToDate,
      Page: 1,
      PageSize: 300,
      Screen: mapScreen[currentTab],
    };
    const name = I18n.t(`common.export.priceData.${currentTab}`, {
      date: getCurrentDate(),
      ticker: displayCode,
    });

    downloadPriceData(apiParams, name);
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = (state, props) => {
  const { id } = props;
  return {
    code: state[REDUCER_NAME].listMultiComponent[id].currentSearch.code,
    i18n: state.i18n,
    displayCode:
      state[REDUCER_NAME].listMultiComponent[id].currentSearch.displayCode,
    timeRangeFilter: state[REDUCER_NAME].listMultiComponent[id].timeRangeFilter,
    dateRangeOption: state[REDUCER_NAME].listMultiComponent[id].dateRangeOption,
  };
};

const mapDispatchToProps = {
  downloadPriceData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
